// test2171
(2171 && 0);
